<template>
  <div id="lossReasonsPage">
    <data-view-sidebar ref="newLossReason" />
    <vs-popup
      class="holamundo"
      title="Kullanıcı Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Zayiat Sebebini Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-row vs-type="flex" vs-w="12" class="mb-1">
      <global-filter
        ref="filterer"
        :tableOptions="tableOptions"
        :filterOptions="filterOptions"
        :filterChips="filterChips"
        :filterOptionNames="filterOptionNames"
        :isActive="isFilterActive"
        @saveOptions="saveOptions"
        @close="isFilterActive = false"
      />
      <vs-row
        id="panelHeaderRow"
        v-show="!isFilterActive"
        vs-type="flex"
        vs-w="12"
        vs-justify="space-between"
      >
        <vs-col
          id="panel-actions"
          vs-type="flex"
          class="w-auto"
          vs-justify="center"
        >
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="flex" class="w-auto" v-if="$isCenterBranch() || $isRegionalCenterBranch()">
              <vx-tooltip text="Yeni Sebep" position="top">
                <vs-button
                  @click="editData({ id: 0, name: null })"
                  class="panel-action text-success xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="feather"
                  icon="icon-plus"
                />
              </vx-tooltip>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Detaylı Filtereleme" position="top">
                <vs-button
                  @click="isFilterActive = !isFilterActive"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="pickicon"
                  icon="icon-pick-filter"
                >
                </vs-button>
              </vx-tooltip>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col id="filter-chips" vs-type="flex">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
          >
            <vs-button
              id="clearFilterButton"
              v-if="filterChips.length > 0"
              @click="clearFilter"
              class="mr-2 bg-white text-danger panel-action-box-shadow"
              icon-pack="feather"
              icon="icon-slash"
              radius
              color="transparent"
            />
            <vs-col
              vs-type="flex"
              class="w-auto"
              v-for="(chip, index) in filterChips"
              :key="index"
            >
              <vs-chip
                color="white"
                class="panel-action-box-shadow px-1"
                @click="removeFilter(chip.col, index)"
                v-show="chip.value != ''"
                closable
              >
                <vs-row vs-tpye="flex" vs-w="12">
                  <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                    <span class="bold text-xsmaller text-dark">
                      {{ chip.name + " :" }}
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                    <span class="weight-600 italic text-xsmaller text-primary">
                      {{ chip.value }}
                    </span>
                  </vs-col>
                </vs-row>
              </vs-chip>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          id="table-page-size"
          vs-type="flex"
          class="w-auto"
          vs-justify="flex-end"
        >
          <vs-dropdown
            vs-trigger-click
            class="bg-white cursor-pointer panel-action-box-shadow"
          >
            <div
              class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
            >
              <span class="mr-2 page-size-dropdown-span"
                >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                -
                {{
                  totalDataRow - (currentPage + 1) * itemsPerPage > 0
                    ? (currentPage + 1) * itemsPerPage
                    : totalDataRow
                }}
                of
                {{ totalDataRow }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-col>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="lossReasonDataList">
      <vs-row
        vs-type="flex"
        vs-w="12"
        class="mb-1"
        id="lossReasonDataListHeader"
      >
        <vs-col
          vs-type="flex"
          vs-w="11"
          vs-justify="center"
          vs-align="center"
          class="p-1"
        >
          <vs-button
            class="p-1 bold text-smaller w-full"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('name')"
            >İsim
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="1"
          vs-justify="center"
          vs-align="center"
          class="p-1"
          v-if="isDeleteLossReasonPermission"
        >
          <span class="p-1 bold text-smaller w-full text-center"> İşlem </span>
        </vs-col>
      </vs-row>
      <vs-row
        vs-type="flex"
        vs-w="12"
        v-for="(lossReason, index) in lossReasons"
        :key="index"
        class="lossReasonRow mb-2 sale-box-shadow bg-white"
      >
        <div class="vs-row w-full pointer" @click="editData(lossReason)">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            vs-align="center"
            class="py-1"
          >
            <vs-col
              vs-type="flex"
              vs-w="11"
              vs-justify="center"
              vs-align="center"
              class="p-1"
            >
              <span class="text-dark weight-600 text-smaller">
                {{ lossReason.name }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="1"
              vs-justify="center"
              vs-align="center"
              class="p-1"
              v-if="($isCenterBranch() || $isRegionalCenterBranch()) && !lossReason.isGlobal"
            >
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="
                  deletedId = lossReason.id;
                  deletePopupActive = true;
                "
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-row>
    </vs-row>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import moduleLossReason from "@/store/lossReason/moduleLossReason.js";
import PaginationDefault from "../PaginationDefault";
import DataViewSidebar from "./NewLossReason.vue";
import {isGranted} from "@/utils/auth";
export default {
  components: {
    PaginationDefault,
    GlobalFilter,
    DataViewSidebar,
  },
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      deletedId: null,
      deletePopupActive: false,

      isFilterActive: false,
      filterOptions: ["lossReason"],
      filterOptionNames: ["İsim"],
      filterChips: [],
      selected: {
        id: 0,
        name: null,
      },
    };
  },
  computed: {
    lossReasons() {
      return this.$store.getters["lossReason/getLossReasons"];
    },
    totalDataRow() {
      return this.$store.getters["lossReason/getTotalDataRow"];
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    isNewLossReasonPermission(){
      return isGranted("loss_reason_write")
    },
    isDeleteLossReasonPermission(){
      return isGranted("loss_reason_delete")
    }
  },
  methods: {
    editData(data) {
      if ((this.$isCenterBranch() || this.$isRegionalCenterBranch()) && !data.isGlobal) {
        this.$refs.newLossReason.isActive = true;
      this.$refs.newLossReason.newLossReason = _.cloneDeep(data);
      }
      
    },
    escape() {
      if (this.deletePopupActive) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    deleteData(id) {
      this.$store
        .dispatch("lossReason/removeLossReason", id)
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "Başarılı !",
            text: "İşlem Başarılı !",
          });
          this.escape();
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        lossReason: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getLossReasonList() {
      this.$store
        .dispatch("lossReason/fetchDataListItemsLossReason", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleLossReason.isRegistered) {
      this.$store.registerModule("lossReason", moduleLossReason);
      moduleLossReason.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.tableOptions = {
      sortBy: "Created",
      sortDirection: "desc",
      pageIndex: 0,
      pageSize: this.itemsPerPage,
      lossReason: null,
    };
    this.filterChips.length = 0;
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getLossReasonList();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
#lossReasonDataList {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
